export default class DiscountReason {
    constructor(props) {
        Object.assign(this, props);
        this.discount = {
            value: props.import,
            type: props.type
        };
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/DiscountReasons/DiscountReason.ts
// module id = 572
// module chunks = 0